<template>
  <v-card class="card" color="primary">
    <v-card-title>
      <div class="text-h5 font-weight-bold">Puesto y dependencia</div>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <template v-if="personal.CatRamaDependencia">
            <v-col cols="8">
              <div class="text-h6 font-weight-bold">Dependencia</div>
            </v-col>
            <v-col cols="4">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="personal.CatRamaDependencia.CatDependencia.catInstancia.title"
                    rounded
                    readonly
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    label="Instancia"
                  ></v-text-field>
                  <v-text-field
                    v-model="personal.CatRamaDependencia.CatDependencia.nombre"
                    rounded
                    readonly
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    label="Nombre"
                  ></v-text-field>
                  <v-text-field
                    v-model="personal.CatRamaDependencia.ramaDependencia"
                    rounded
                    readonly
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    label="Dirección"
                  ></v-text-field>
                  <template v-if="personal.CatSubArea">
                    <v-text-field
                      v-model="personal.CatSubArea.CatArea.nombre"
                      rounded
                      readonly
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Área"
                    ></v-text-field>
                    <v-text-field
                      v-model="personal.CatSubArea.nombre"
                      rounded
                      readonly
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Sub-área"
                    ></v-text-field>
                  </template>
                  <template v-else>
                    <v-text-field
                      value=""
                      rounded
                      readonly
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Área"
                    ></v-text-field>
                    <v-text-field
                      value=""
                      rounded
                      readonly
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Sub-área"
                    ></v-text-field>
                  </template>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </template>
          <v-col cols="8">
            <div class="text-h6 font-weight-bold">Puesto</div>
          </v-col>
          <v-col cols="4" v-if="personal.CatPuestoDependencia">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-if="personal.CatPuestoDependencia.CatTipoPuesto"
                  v-model="personal.CatPuestoDependencia.CatTipoPuesto.title"
                  rounded
                  readonly
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Tipo de Puesto"
                ></v-text-field>
                <v-text-field
                  v-else
                  value=""
                  rounded
                  readonly
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Tipo de Puesto"
                ></v-text-field>
                <v-text-field
                  v-model="personal.CatPuestoDependencia.catPuesto.puesto"
                  rounded
                  readonly
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Puesto"
                ></v-text-field>
                <v-text-field
                  v-if="perfil == PERFILES['Recursos Humanos']"
                  v-model="personal.plaza"
                  rounded
                  readonly
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Plaza"
                ></v-text-field>
                <v-text-field
                  v-if="personal.CatTurno"
                  v-model="personal.CatTurno.title"
                  rounded
                  readonly
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Turno"
                ></v-text-field>
                <v-text-field
                  v-else
                  rounded
                  readonly
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Turno"
                ></v-text-field>
                <v-textarea
                  v-model="personal.CatPuestoDependencia.funciones"
                  rounded
                  readonly
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Funciones"
                  no-resize
                  rows="4"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="8">
            <div class="text-h6 font-weight-bold">Datos de nuevo ingreso</div>
          </v-col>
          <v-col cols="4">
            <v-row>
              <v-col cols="12">
                <v-checkbox
                  v-model="ingresoAspirante"
                  label="Este elemento inició como aspirante"
                  color="secondary"
                  hide-details
                  class="mt-0"
                  :loading="updatingAspirante"
                  @change="handleIngresoAspiranteChange"
                ></v-checkbox>
                <v-checkbox
                  v-model="reclutadoPolicial"
                  label="Este elemento inició como aspirante y fue reclutado como policía"
                  color="secondary"
                  :loading="updatingReclutado"
                  @change="handleReclutadoPolicialChange"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="8">
            <div class="text-h6 font-weight-bold">Puesto</div>
          </v-col>
          <v-col cols="4">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="personal.fk_idSubsede"
                  rounded
                  filled
                  dense
                  :items="subsedes"
                  item-value="id"
                  item-text="nombre"
                  background-color="primary"
                  color="secondary"
                  label="Subsede"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="8">
            <div class="text-h6 font-weight-bold">Grado Homologado</div>
          </v-col>
          <v-col cols="4">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="personal.fk_idCatGradoHomologado"
                  rounded
                  filled
                  dense
                  :items="tipoGradoHomologado"
                  item-value="id"
                  item-text="title"
                  background-color="primary"
                  color="secondary"
                  label="Grado Homologado"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="8">
            <div class="text-h6 font-weight-bold">Fecha de alta</div>
          </v-col>
          <v-col cols="4">
            <v-row>
              <v-col cols="12" class="text-right">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Fecha de alta"
                      :value="fechaAlta"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      rounded
                      filled
                      dense
                      color="secondary"
                      background-color="primary"
                    />
                  </template>
                  <v-date-picker v-model="selectedDate" @input="menu = false" no-title></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="8">
            <div class="text-h6 font-weight-bold">Numero de empleado</div>
          </v-col>
          <v-col cols="4">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="personal.unidadAnalisisTactico"
                  rounded
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Numero de empleado"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="text-right">
            <TextButton :loading="loadingGuardar" color="secondary" class="primary--text mb-3" @click="saveAll">
              Guardar Cambios
            </TextButton>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import DateAdapter from '@src/utils/DateAdapter'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BaseTextInput from '../base/BaseTextInput.vue'
import TextButton from '../base/TextButton.vue'
import { PERFILES } from '@/perfiles.js'
import { API_DATE_FORMAT, VUETIFY_DATE_FORMAT } from '@src/const'

export default {
  components: {
    BaseTextInput,
    TextButton,
  },

  props: {
    personal: {
      type: Object,
    },
  },

  data() {
    return {
      loadingGuardar: false,
      menu: false,
      selectedDate: this.personal.fechaIngresoEdoFza
        ? new DateAdapter(this.personal.fechaIngresoEdoFza, API_DATE_FORMAT).toUiSupportedFormat()
        : null,
      PERFILES,
      updatingAspirante: false,
      updatingReclutado: false,
      ingresoAspirante: false,
      reclutadoPolicial: false,
    }
  },

  computed: {
    ...mapGetters({ perfil: 'getPerfil' }),
    ...mapGetters('subsede', { subsedes: 'getSubsedes' }),
    ...mapGetters('gradoHomologado', { tipoGradoHomologado: 'getGradoHomologado' }),

    fechaAlta() {
      if (!this.selectedDate) {
        return ''
      }

      return new DateAdapter(this.selectedDate, VUETIFY_DATE_FORMAT).toHumanReadable()
    },
  },

  watch: {
    personal: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.ingresoAspirante = newVal.ingresoAspirante || false
          this.reclutadoPolicial = newVal.reclutadoPolicial || false
        }
      },
    },
  },

  mounted() {
    this.fetchGradoHomologado()
    this.fetchSubsedes()
  },

  methods: {
    ...mapActions('personal', ['updatePersonal']),
    ...mapActions('gradoHomologado', ['fetchGradoHomologado']),
    ...mapActions('subsede', ['fetchSubsedes']),
    ...mapActions('aspirantes', ['updateAspiranteStatus', 'updateAspiranteReclutedToPolicia']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async saveAll() {
      try {
        this.loadingGuardar = true

        const payload = {
          ...this.personal,
          fk_idCatGradoHomologado: this.personal.fk_idCatGradoHomologado,
          fechaIngresoEdoFza: this.selectedDate
            ? new DateAdapter(this.selectedDate, VUETIFY_DATE_FORMAT).toApiSupportedFormat()
            : this.personal.fechaIngresoEdoFza,
          unidadAnalisisTactico: this.personal.unidadAnalisisTactico,
          fk_idSubsede: this.personal.fk_idSubsede,
        }

        await this.updatePersonal(payload)
        await this.$store.dispatch('personal/fetchPersonalById', this.personal.idPersonal)

        this.SET_SNACKBAR_MESSAGE('Cambios guardados exitosamente.')
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('No fue posible guardar los cambios.')
      } finally {
        this.loadingGuardar = false
      }
    },

    async handleIngresoAspiranteChange(value) {
      this.updatingAspirante = true
      try {
        await this.updateAspiranteStatus({ idPersonal: this.personal.idPersonal, ingresoAspirante: value })
      } catch (error) {
        if (error.response?.data?.error_code !== 500) {
          this.ingresoAspirante = !value
        }
        console.error('Error al actualizar ingreso aspirante:', error)
      } finally {
        this.updatingAspirante = false
      }
    },

    async handleReclutadoPolicialChange(value) {
      this.updatingReclutado = true
      try {
        await this.updateAspiranteReclutedToPolicia({ idPersonal: this.personal.idPersonal, reclutadoPolicial: value })
      } catch (error) {
        if (error.response?.data?.error_code !== 500) {
          this.reclutadoPolicial = !value
        }
        console.error('Error al actualizar reclutado policial:', error)
      } finally {
        this.updatingReclutado = false
      }
    },
  },
}
</script>
